import * as Turbo from "@hotwired/turbo";
import { Controller } from "stimulus";
import { useDispatch } from 'stimulus-use';

export default class extends Controller {
  static targets = ['button'];

  connect() {
    useDispatch(this);

    // Define some callback functions as arrow functions here so they are bound
    // to our controller instance
    this.beforeVisitCallback = (ev) => { this.onBeforeVisit(ev); };
    this.changeCallback = (ev) => { this.onChange(ev); };
    this.submitCallback = (ev) => { this.saving = true; };

    //this.buttonTarget.disabled = true;
    this.element.addEventListener('submit', this.submitCallback, false);
    this.element.addEventListener('change', this.changeCallback, false);
    this.element.addEventListener('keyup', this.changeCallback, false);

    // Controller state values
    this.discarding = false; // flipped when discard changes are hit
    this.saving = false;     // flipped when the form is submitted
    this.values = new Map(); // keep track of initial values

    this.queryForFields().forEach(field => {
      switch(field.type) {
        case 'checkbox':
          this.values.set(field.name, field.checked);
          break;

        default:
          this.values.set(field.name, field.value);
          break;
      }
    });
  }

  disconnect() {
    this.element.removeEventListener('submit', this.submitCallback, false);
    this.element.removeEventListener('change', this.changeCallback, false);
    this.element.removeEventListener('keyup', this.changeCallback, false);

    document.removeEventListener('turbo:before-visit', this.beforeVisitCallback);
  }

  queryForFields() {
    return Array.from(this.element.querySelectorAll('input:not([type="hidden"]), select'));
  }

  hasChanges() {
    return this.queryForFields().some(f => this.values.get(f.name) !== f.value);
  }

  keepEditing() {
    this.hideUnsavedChangesPrompt();

    delete this.visitUrl;
  }

  discardChanges() {
    if (this.visitUrl) {
      this.discarding = true;
      this.hideUnsavedChangesPrompt();

      Turbo.visit(this.visitUrl);
    }
  }

  hideUnsavedChangesPrompt() {
    this.dispatch('promptClosed');
  }

  onBeforeVisit(ev) {
    // Do the default behavior if we're either saving the form or discarding
    // changes on navigation
    if (this.discarding || this.saving)
      return;

    // Prevent navigation
    ev.preventDefault();

    // Save the URL we were requesting for later
    this.visitUrl = ev.detail.url;

    this.dispatch('unsavedChanges');
  }

  onChange(ev) {
    if (this.hasChanges()) {
      //this.buttonTarget.disabled = false;

      document.addEventListener('turbo:before-visit', this.beforeVisitCallback);
    } else {
      //this.buttonTarget.disabled = true;

      document.removeEventListener('turbo:before-visit', this.beforeVisitCallback);
    }
  }
}
